import { OverlayView } from '@react-google-maps/api';
import { Cluster } from '../../types/cluster';
import { EstablishmentCompanyData } from '@/common/types/establishment/company.type';
import { EstablishmentTooltipDetails } from './EstablishmentTooltipDetails';
import { twMerge } from 'tailwind-merge';
import { useEstablishmentMap } from '../../stores/useEstablishmentMap.store';
import { LoadingEstablishmentTooltipDetails } from './LoadingTooltipDetails';

interface MarkerTooltipProps {
  cluster: Partial<Cluster>;
  establishment?: EstablishmentCompanyData;
  isLoadingEstablishmentData: boolean;
}

export const MarkerTooltip = ({ cluster, establishment, isLoadingEstablishmentData }: MarkerTooltipProps) => {
  const { colorScheme } = useEstablishmentMap();

  return (
    <OverlayView
      position={{
        lat: Number(cluster.latitude),
        lng: Number(cluster.longitude),
      }}
      mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
    >
      <div className='mb-12'>
        <div className={
          twMerge(
            'establishment-map-tooltip tooltip-content items-start justify-between w-[336px] backdrop-blur-3xl flex-col bg-white-200 z-50 rounded-md absolute bottom-[50px]',
            colorScheme === 'light' && 'bg-map-search-75'
          )
        }>
          {isLoadingEstablishmentData ? (
            <LoadingEstablishmentTooltipDetails />
          ) : (
            <EstablishmentTooltipDetails establishment={establishment} />
          )}
        </div>
      </div>
    </OverlayView>
  );
};
